import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { KeyMetrics } from './components/KeyMetrics';
import { ValuePillars } from './components/ValuePillars';
import { CareerHighlights } from './components/CareerHighlights';
import { CaseStudy } from './components/CaseStudy';
import { ExperienceSection } from './components/ExperienceSection';
import { Education } from './components/Education';
import { Certifications } from './components/Certifications';
import { MediaAuthority } from './components/MediaAuthority';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#FDFBF7] relative overflow-hidden bg-noise bg-lines" data-id="element-0">
      {/* Floating ambient orbs */}
      <div className="floating-orb floating-orb-1" style={{
      top: '5%',
      left: '-5%'
    }} data-id="element-1" />
      <div className="floating-orb floating-orb-2" style={{
      top: '30%',
      right: '-3%'
    }} data-id="element-2" />
      <div className="floating-orb floating-orb-3" style={{
      top: '60%',
      left: '10%'
    }} data-id="element-3" />
      <div className="floating-orb floating-orb-2" style={{
      top: '80%',
      right: '5%'
    }} data-id="element-4" />

      <Header data-id="element-5" />
      <main className="relative z-10" data-id="element-6">
        <div className="bg-hero-glow" data-id="element-7">
          <HeroSection data-id="element-8" />
        </div>
        <div className="section-divider" data-id="element-9" />
        <KeyMetrics data-id="element-10" />
        <div className="section-divider" data-id="element-11" />
        <div className="relative corner-flourish" data-id="element-12">
          <ValuePillars data-id="element-13" />
        </div>
        <div className="section-divider" data-id="element-14" />
        <CareerHighlights data-id="element-15" />
        <div className="section-divider" data-id="element-16" />
        <div className="relative corner-flourish" data-id="element-17">
          <CaseStudy data-id="element-18" />
        </div>
        <div className="section-divider" data-id="element-19" />
        <div className="relative corner-flourish" data-id="element-20">
          <ExperienceSection data-id="element-21" />
        </div>
        <div className="section-divider" data-id="element-22" />
        <div className="bg-dots" data-id="element-23">
          <Education data-id="element-24" />
        </div>
        <div className="section-divider" data-id="element-25" />
        <Certifications data-id="element-26" />
        <div className="section-divider" data-id="element-27" />
        <div className="relative corner-flourish" data-id="element-28">
          <MediaAuthority data-id="element-29" />
        </div>
      </main>
      <Footer data-id="element-30" />
    </div>;
}